import { Link } from "react-router";

import { nl } from "../i18n/nl";
import styles from "./Placeholder.module.css";

export function NotFound() {
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{nl.notFound.title}</h1>
      <p className={styles.body}>{nl.notFound.body}</p>
      <Link className={styles.link} to="/">
        {nl.notFound.back}
      </Link>
    </div>
  );
}
